import { Component, defineComponent } from 'vue';
import Breadcrumbs from './Breadcrumbs.class';
import Breadcrumb from './breadcrumb/Breadcrumb.vue';
export default defineComponent({
	components:{
		Breadcrumb: Breadcrumb as Component,
	},
	setup: () => {
		const component = new Breadcrumbs();
		return {
			...component,
		};
	},
})